<template lang="">
     <div class="componente" :style="{width: width, height:heigth, position: position, top:top, left:left }">
       <v-select
        :items="programas"
        item-text="name"
        item-value="value"
        v-model="nuevo_valor"
        disabled
       >

       </v-select>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
    methods: {
        ...mapActions("nodered",['doPublish'])
    },

    data() {
        return {
            programas:[
                {'name':'Programa 1','value':0},
                {'name':'Programa 2','value':1},
            ],
            nuevo_valor:'',
        }
    },
    watch:{
        valor(v){
            this.nuevo_valor=v;
        },
        nuevo_valor(valor){
            let publication={
              topic:'SELECTOR_PROGRAMA',
              qos:2,
              payload:JSON.stringify({'valor':valor}) ,
            }
            this.doPublish(publication)
        }
    },
    created() {
        this.nuevo_valor=this.valor
    },
    props:{
        heigth: String,
        width: String,
        position: String,
        top:String,
        left: String,
        titulo: String,

        valor:Number,
        unidad:String
    },
    
}
</script>
<style >
    .componente{
        position: absolute;
   
    }
</style>